import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useAdsCopilotStyles = makeStyles({
  provider: {
    height: '100%',
  },
  wrapper: {
    height: '100%',
  },
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: tokens.colorNeutralBackground2,
    borderLeftWidth: '1px',
    borderLeftStyle: 'solid',
    borderLeftColor: tokens.colorNeutralStroke1,
    '& .fai-Textarea': {
      alignSelf: 'center',
      maxWidth: '652px',
      width: '100%',
      '& .fai-Textarea__count': {
        position: 'absolute',
        bottom: tokens.spacingVerticalXXL,
        left: tokens.spacingVerticalM,
      },
    },
  },
  container: {
    ...shorthands.flex(1),
    width: '100%',
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    paddingTop: 0,
    paddingBottom: tokens.spacingHorizontalL,
    '& .scrollbar-hidden': {
      '& .ads-copilot-loading': {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
      },
    },
  },
});
